import ExcelJS from 'exceljs'
import { ALLOCATIONS_HEADERS, COMPANIES_HEADERS, GUESTS_HEADERS, autoSizeColumns, downloadBlob, styleHeaderRow, workbookToBlob } from './shared'

/** Builds the downloadable master import template (section 33): 3 sheets with headers + one worked example each, ready for an admin to fill in and re-upload via the Master Bulk Import workflow. */
export async function buildMasterTemplate(eventName: string): Promise<void> {
  const wb = new ExcelJS.Workbook()
  wb.creator = 'Rooming List'
  wb.created = new Date()

  const companies = wb.addWorksheet('Companies')
  companies.addRow(COMPANIES_HEADERS)
  styleHeaderRow(companies.getRow(1))
  companies.addRow(['EVA', 'EVA Pharma', 'Ahmed Ali', '01000000000', 'example@email.com', '2027-10-15 23:59', 'Open', ''])
  companies.views = [{ state: 'frozen', ySplit: 1 }]
  autoSizeColumns(companies)

  const allocations = wb.addWorksheet('Allocations')
  allocations.addRow(ALLOCATIONS_HEADERS)
  styleHeaderRow(allocations.getRow(1))
  allocations.addRow(['EVA', 'Hilton Alexandria', 'Single', 10, 1, '2027-10-10', '2027-10-13', ''])
  allocations.addRow(['EVA', 'Hilton Alexandria', 'Double', 2, 2, '2027-10-10', '2027-10-13', ''])
  allocations.addRow(['EVA', 'Four Seasons', 'Suite', 3, 2, '2027-10-10', '2027-10-13', ''])
  allocations.addRow(['EVA', 'Four Seasons', 'Royal Suite', 4, 4, '2027-10-10', '2027-10-13', ''])
  allocations.views = [{ state: 'frozen', ySplit: 1 }]
  autoSizeColumns(allocations)

  const guests = wb.addWorksheet('Guests')
  guests.addRow(GUESTS_HEADERS)
  styleHeaderRow(guests.getRow(1))
  guests.addRow(['EVA', 'Hilton Alexandria', 'Double', 1, 1, 'Ahmed Ali', '01000000001', '', '2027-10-10', '2027-10-13', '', ''])
  guests.addRow(['EVA', 'Hilton Alexandria', 'Double', 1, 2, 'Mohamed Adel', '01000000002', '', '2027-10-10', '2027-10-13', '', ''])
  guests.views = [{ state: 'frozen', ySplit: 1 }]
  autoSizeColumns(guests)

  const readme = wb.addWorksheet('Read Me', { properties: { tabColor: { argb: 'FFEAB308' } } })
  readme.addRow(['Master Import Template'])
  readme.getRow(1).font = { bold: true, size: 14 }
  readme.addRow([`Event: ${eventName}`])
  readme.addRow([''])
  readme.addRow(['1. Companies sheet: one row per company. Company Code must be unique within the event.'])
  readme.addRow(['2. Allocations sheet: one row per (Company, Hotel, Room Type). Room slots are generated automatically from Room Count / Capacity Per Room.'])
  readme.addRow(['3. Guests sheet is optional. Room Slot / Guest Slot are 1-based positions within that allocation (e.g. Double room 1, guest 2).'])
  readme.addRow(['4. Leave "Guest ID (internal)" blank for a new import -- it is filled in automatically on export, for accurate re-import later.'])
  readme.addRow(['5. Upload this file from Import / Export -> Master Bulk Import. You will see a preview before anything is saved.'])
  readme.columns = [{ width: 100 }]

  const blob = await workbookToBlob(wb)
  downloadBlob(blob, `${eventName.replace(/[^A-Za-z0-9]+/g, '_')}_master_import_template.xlsx`)
}
